import styled from 'styled-components'
import { INTRO_ACCENT_COLOR } from '~/pages/anatomyV2/intro/libs/components/AnatomyV2Intro/constants'
import {
  anatomyV2ContentWrapperCss,
  anatomyV2RootCss,
} from '~/pages/anatomyV2/libs/pageLayoutStyles'
import {
  ANATOMY_V2_COMPACT,
  anatomyV2Compact,
} from '~/pages/anatomyV2/libs/responsive'
import { COLORS } from '~/shared/constants/uiConstants'

export const AnatomyV2IntroStyles = {
  Root: styled.div`
    ${anatomyV2RootCss}
    overflow: hidden;
  `,

  ContentWrapper: styled.div`
    ${anatomyV2ContentWrapperCss}
    align-items: center;
    justify-content: safe center;
    padding: 24px 16px 150px;
    overflow: hidden;

    ${anatomyV2Compact} {
      padding: 24px 16px;
    }
  `,

  Title: styled.h1`
    font-size: 32px;
    font-weight: 700;
    line-height: 38px;
    text-align: center;
    color: ${COLORS.BLACK};
    margin-bottom: 10px;

    span {
      color: ${INTRO_ACCENT_COLOR};
      font-weight: inherit;
    }

    ${anatomyV2Compact} {
      font-size: ${ANATOMY_V2_COMPACT.fontSize.f32};
      line-height: ${ANATOMY_V2_COMPACT.lineHeight.lh38};
    }
  `,

  Subtitle: styled.p`
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: ${COLORS.GRAY_700};
    margin-bottom: 24px;

    ${anatomyV2Compact} {
      font-size: ${ANATOMY_V2_COMPACT.fontSize.f15};
      line-height: ${ANATOMY_V2_COMPACT.lineHeight.lh20};
      margin-bottom: ${ANATOMY_V2_COMPACT.spacing.s24};
    }
  `,

  Badges: styled.div`
    display: flex;
    gap: 16px;
    justify-content: center;
    margin-bottom: 50px;

    ${anatomyV2Compact} {
      margin-bottom: ${ANATOMY_V2_COMPACT.spacing.s50};
    }
  `,

  Badge: styled.span`
    display: inline-flex;
    align-items: center;
    padding: 1px 5px;
    border-radius: 999px;
    background-color: #dad5ff;
    font-size: 13px;
    color: ${INTRO_ACCENT_COLOR};
    letter-spacing: -0.154px;
  `,

  ImageWrapper: styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: 100%;
    max-height: min(360px, 45dvh);
  `,

  Picture: styled.picture`
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
  `,

  Image: styled.img`
    max-height: min(360px, 45dvh);
    object-fit: contain;
  `,

  LetterBadge: styled.span<{ $corner: 'a' | 'b' | 'c' | 'd' }>`
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    background-color: ${COLORS.WHITE};
    color: #000000;
    font-size: 16px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ $corner }) =>
      ({
        a: 'top: 47%; left: 49%; transform: translate(-108%, -108%);',
        b: 'top: 47%; right: 49%; transform: translate(108%, -108%);',
        c: 'bottom: 50%; left: 49%; transform: translate(-108%, 108%);',
        d: 'bottom: 50%; right: 49%; transform: translate(108%, 108%);',
      }[$corner])};
  `,

  LoaderSection: styled.div`
    width: 100%;
    margin-top: 24px;

    ${anatomyV2Compact} {
      margin-top: ${ANATOMY_V2_COMPACT.spacing.s24};
    }
  `,

  LoaderText: styled.p`
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: ${COLORS.BLACK};
    margin-bottom: 8px;
  `,

  ProgressWrapper: styled.div`
    width: 100%;
    height: 16px;
    border-radius: 14px;
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #d4c5ff;
  `,
}
